import { useDispatch } from 'react-redux'
import {
  messageBoxShowAction,
  messageBoxHideAction,
} from 'src/reducers/message-box/action'
import { aICreatorUpdateOutlineAction } from 'src/reducers/ai-creator/action'
import { ButtonData, ButtonType, ButtonActionType } from 'src/model/button'
import MessageBoxContent, { MessageBoxType } from 'src/model/message-box'
import AddSubheaderModal from 'src/components/add-subheader-modal'

export const usePageManagement = (data, dispatch, modalRef, setCreditCost) => {
  const localDispatch = useDispatch()

  const handleAddPageWithDocument = sectionIndex => {
    if (modalRef.current) {
      modalRef.current.resetState()
    }

    // Create a variable to store the selected title that will be accessible in the button click
    let selectedTitle = null
    localDispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          buttons: [
            new ButtonData(
              ButtonType.NORMAL,
              'Cancel',
              ButtonActionType.NO,
              () => {
                localDispatch(messageBoxHideAction())
              },
            ),
            new ButtonData(
              ButtonType.ACTION,
              'Add',
              ButtonActionType.ADD,
              () => {
                handleAddPage(selectedTitle, sectionIndex)
              },
            ),
          ],
          title: 'Add a page',
          component: (
            <AddSubheaderModal
              ref={modalRef}
              outline={data.response.outline}
              outlineId={data.response.outlineId}
              moduleIndex={sectionIndex}
              sectionIndex={sectionIndex}
              onTitleSelect={title => {
                selectedTitle = title
              }}
              isCourseHasDocument={true}
            />
          ),
        }),
      ),
    )
  }

  const handleAddPage = (selectedTitle, sectionIndex) => {
    if (selectedTitle) {
      if (!selectedTitle.text || selectedTitle.text.trim().length < 2) {
        if (modalRef.current) {
          modalRef.current.setShowError(true)
        }
        return
      }

      const newData = [...data.response.outline.sections]
      const newModule = {
        element_id: selectedTitle.element_id,
        module_title: selectedTitle.text,
        content_type: selectedTitle.content_type,
        goals: [],
        attachment: selectedTitle.attachment_id
          ? {
              id: selectedTitle.attachment_id,
              name: selectedTitle.fileName,
              page_start: selectedTitle.page_start,
              page_end: selectedTitle.page_end,
              start_seconds: selectedTitle.start_seconds,
              end_seconds: selectedTitle.end_seconds,
              url: selectedTitle.url,
            }
          : null,
      }

      newData[sectionIndex].modules.push(newModule)

      // Update data with new structure and trigger outline update
      dispatch(
        aICreatorUpdateOutlineAction(
          { outline: { ...data.response.outline, sections: newData } },
          data.response.outlineId,
        ),
        response => {
          setCreditCost(response.credit_cost)
        },
      )
      localDispatch(messageBoxHideAction())
    } else {
      if (modalRef.current) {
        modalRef.current.validateSelection()
      }
    }
  }

  const getFileInfo = module => {
    if (module.attachment) {
      return {
        name: module.attachment.name,
        chapter: module.element_id || 'No chapter specified',
      }
    }
    return null
  }

  return {
    handleAddPageWithDocument,
    handleAddPage,
    getFileInfo,
  }
}
